export const downloads = {
  seo: {
    title: 'Téléchargements | Bistroo',
    description: "Téléchargez l'application Bistroo Manager pour iOS et Android. Gérez votre restaurant facilement depuis votre smartphone.",
  },
  title: 'Téléchargements',
  subtext: 'Sur cette page, vous trouverez un aperçu de toutes les versions de Bistroo Manager',
  operating_system: {
    win: 'Windows',
    mac_os: 'Mac OSX',
  },
  supported_subversions: {
    win: 'Windows 7, Windows 8, Windows 10, Windows 11',
    mac_os: 'Ventura, Monterey, Big Sur',
  },

  btn_text: 'Télécharger',

  latest_version_text:
    'Téléchargez la dernière version de Bistroo Manager pour {os}. Actuellement, il s\'agit de la version {version}',

  previous_versions_title: 'Versions précédentes',
  previous_versions_subtext:
    'Sur cette page, vous trouverez un aperçu de toutes les versions de Bistroo Manager',
}
